<script setup>
import { onMounted } from "vue";
import useMyInitiativeTable from "./hooks/useMyInitiativeTable";
import useMyInitiativeAdjust from "./hooks/useMyInitiativeAdjust";
import {
  PROCESS_COMPLETE_TYPE,
  PROCESS_COMPLETE_TYPE_OBJECT,
} from "@/constants";
import adjust from "./adjust.vue";

const {
  searchRef,
  searchData,
  tableLoading,
  tableData,
  columns,
  pages,
  getList,
  handleReset,
} = useMyInitiativeTable();

const { adjustRef, handleRevocation, handleDelete, handleDetail } =
  useMyInitiativeAdjust(getList);

// tag主题
const tagColor = {
  act_complete_type_001: "success",
  act_complete_type_002: "warning",
};
onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '我的发起' }">
    <template #header-btn />
    <template #search>
      <el-form :model="searchData" ref="searchRef" :inline="true">
        <el-form-item prop="processDefinitionName">
          <el-input
            v-model="searchData.processDefinitionName"
            placeholder="流程名称"
          />
        </el-form-item>
        <el-form-item prop="processDefinitionKey">
          <el-input
            v-model="searchData.processDefinitionKey"
            placeholder="流程key"
          />
        </el-form-item>
        <el-form-item prop="completeType">
          <el-select
            v-model="searchData.completeType"
            placeholder="流程状态"
            style="width: 100%"
          >
            <el-option
              v-for="item in PROCESS_COMPLETE_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="getList()"
            >搜索</el-button
          >
          <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        v-loading="tableLoading"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <el-tag
                v-if="item.prop == 'completeType'"
                :type="tagColor[row[item.prop]]"
                >{{ PROCESS_COMPLETE_TYPE_OBJECT[row[item.prop]] }}</el-tag
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="150">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleDetail(row)"
              >详情</el-button
            >
            <el-button type="primary" link @click="handleRevocation(row)"
              >撤回</el-button
            >
            <el-button type="danger" link @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :total="pages.total"
        v-model:current-page="pages.page"
        @update:current-page="getList"
        layout="->, prev, pager, next"
      />
    </template>
  </zh-table-page>

  <adjust ref="adjustRef" />
</template>

<style scoped></style>
